<template>
    <div class="members">
        <button v-if="position === 'left'" @click.prevent="toggle" class="lc-open-members-popup pill">
            <icon type="user" color="bluegray" size="16" />
            <icon type="plus" color="bluegray" size="14" />
        </button>

        <avatar class="lc-member-item" v-for="member in truncatedMembers" :key="member.id" :user="member.user" />

        <div v-if="remainder" class="avatar">
            <div class="avatar__initials">
                <span>+ {{ remainder }}</span>
            </div>
        </div>

        <button v-if="position === 'right'" @click.prevent="toggle" class="lc-open-members-popup pill">
            <icon type="user" color="bluegray" size="16" />
            <icon type="plus" color="bluegray" size="14" />
        </button>

        <div v-if="isOpen" class="lc-members-popup dropdown-menu" :class="{[`dropdown-menu--${position}`]: true}">
            <ul class="p-0" role="menu" :aria-expanded="isOpen">
                <li v-for="member in members" :key="member.id" class="dropdown-menu__item" role="menuitem">
                    <a href="#" @click.stop="removeMember(member)" class="dropdown-menu__link lc-added-member-item member" :class="`lc-remove-member-${member.id}`">
                        <avatar class="member__avatar" :user="member.user"></avatar>
                        <span class="member__name">{{ member.user.display_name }}</span>

                        <icon class="member__check" type="check-mark" color="secondary" size="18"></icon>
                        <icon class="member__remove" type="minus" color="tertiary" size="18"></icon>
                    </a>
                </li>
            </ul>

            <div v-if="canAddMore" class="members__search">
                <input type="text" v-model="search" class="lc-memeber-search form__input" placeholder="Search for users">
            </div>

            <ul v-if="hasAvailableUsers" class="p-0" role="menu" :aria-expanded="isOpen">
                <li :key="user.id" v-for="user in availableActiveMembers" class="dropdown-menu__item" role="menuitem">
                    <a href="#" @click.stop="addMember(user)" class="dropdown-menu__link lc-channel-member-item member" :class="`lc-channel-member-${user.id}`">
                        <avatar class="member__avatar" :user="user" />
                        <span class="member__name">{{ user.display_name }}</span>

                        <icon type="plus" color="tertiary" />
                    </a>
                </li>
            </ul>

            <div v-if="users.length === 0" class="dropdown-menu__item">
                There is no people
                <a v-if="currentUser.is_administrator" href="/account/settings/people">
                    add people
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Toggleable from '../../mixins/toggle'
import Avatar from './Avatar'
import Icon from './Icon'
import { mapState } from 'vuex'

const MAX_MEMBERS = 4

export default {
    mixins: [Toggleable],

    props: {
        value: {
            required: false,
            type: Array,
            default () {
                return []
            }
        },

        position: {
            type: String,
            default: 'left'
        },

        users: {
            required: true,
            type: Array
        }
    },

    data () {
        return {
            search: '',
            isBusy: false,
            members: []
        }
    },

    created () {
        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.close()
            }
        })
    },

    mounted () {
        if (this.value.length) {
            this.value.forEach((userId) => {
                let user = this.users.find((user) => user.id === userId)

                if (user) {
                    this.members.push({ user })
                }
            })
        }
    },

    methods: {
        isMember (user) {
            return this.members.some((member) => member.user.id === user.id)
        },

        addMember (user) {
            if (this.isMember(user) === false) {
                this.members.push({ user })
                this.updateValue()
            }
        },

        removeMember (memberToRemove) {
            this.members = this.members.filter((member) => member.user.id !== memberToRemove.user.id)
            this.updateValue()
        },

        updateValue () {
            this.$emit('input', this.members.map((member) => member.user.id))
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        availableActiveMembers () {
            let search = this.search.toLowerCase()

            return this.users.filter((user) => {
                return user.display_name.toLowerCase().includes(search) && !this.isMember(user)
            })
        },

        canAddMore () {
            return this.users.length !== this.members.length
        },

        hasAvailableUsers () {
            return this.availableActiveMembers.length > 0
        },

        hasMembers () {
            return this.members.length > 0
        },

        truncatedMembers () {
            if (this.members.length > MAX_MEMBERS) {
                return this.members.slice(0, MAX_MEMBERS - 1)
            }

            return this.members.slice(0, MAX_MEMBERS)
        },

        remainder () {
            if (this.members.length > MAX_MEMBERS) {
                return this.members.length - (MAX_MEMBERS - 1)
            }

            return null
        }
    },

    components: {
        Avatar,
        Icon
    }
}
</script>
